import React from 'react'

import { Option as OptionProps } from 'constants/models'

import { ModalBox } from 'components'

import i18n from 'translations'

import AddAdministrationModalForm, { AddAdministrationFormValues } from './components/AddAdministrationModalForm'

interface AddAdministrationModalViewProps {
  doseOptions?: OptionProps[]
  formValues: AddAdministrationFormValues
  initialValues?: AddAdministrationFormValues
  isChildContext: boolean
  isSubmitting: boolean
  medicineOptions?: OptionProps[]
  onCancelClick?: () => void
  onSubmit: (fields: AddAdministrationFormValues) => void
}

const AddAdministrationModalView: React.FC<AddAdministrationModalViewProps> = ({
  doseOptions,
  formValues,
  initialValues,
  isChildContext,
  isSubmitting,
  medicineOptions,
  onCancelClick,
  onSubmit,
}) => (
  <ModalBox
    scrollToBody={false}
    title={i18n.t('modals:Administration:AddAdministration:addTitle')}
    iosPolyfill
    onCloseClick={onCancelClick}
  >
    <AddAdministrationModalForm
      doseOptions={doseOptions}
      formValues={formValues}
      initialValues={initialValues}
      isChildContext={isChildContext}
      isSubmitting={isSubmitting}
      medicineOptions={medicineOptions}
      onCancelClick={onCancelClick}
      onSubmit={onSubmit}
    />
  </ModalBox>
)

export default AddAdministrationModalView
